import { render, staticRenderFns } from "./coll.vue?vue&type=template&id=15620564&scoped=true&"
import script from "./coll.vue?vue&type=script&lang=js&"
export * from "./coll.vue?vue&type=script&lang=js&"
import style0 from "./coll.vue?vue&type=style&index=0&id=15620564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15620564",
  null
  
)

export default component.exports